import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import Text from '../../../../../Text'
import { QA_NAME_APPLICANT_CREDIT_CHECK_RETRY } from '../ApplicantCreditCheckBlock.constants'

import * as styles from '../ApplicantCreditCheckBlock.module.css'

function ApplicantCreditCheckLoadError({ onRetry }) {
  const { t } = useTranslation()

  return (
    <div className={styles.body}>
      <Text isSecondary className={styles.line}>
        {t('RentalPortal.ApplicantCreditCheckLoadErrorKey')}
      </Text>
      <Button.Outlined
        isGrey
        className={styles.retry}
        height={BUTTON_HEIGHT_32}
        qaName={QA_NAME_APPLICANT_CREDIT_CHECK_RETRY}
        text={t('RentalPortal.ListingRetryBtnKey')}
        type='button'
        onClick={onRetry}
      />
    </div>
  )
}

export default ApplicantCreditCheckLoadError
